module.exports = __webpack_public_path__ + "media/testimonials/property-6-5ed2a5fd.jpg";